import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { useLocation } from 'react-router-dom'
import {
  StyledContainer,
  SchoolIcon,
  getIconDefaultColor,
} from './component.styles'

const CurrentSiteTile = props => {
  const { currentSite, handleClick } = props
  const location = useLocation()

  // Recalculate the icon color whenever the URL changes
  const iconColor = useMemo(() => {
    return getIconDefaultColor()
  }, [location.pathname])

  return (
    currentSite && (
      <StyledContainer iconColor={iconColor} onClick={handleClick}>
        <SchoolIcon />
        {currentSite}
      </StyledContainer>
    )
  )
}

CurrentSiteTile.propTypes = {
  currentSite: PropTypes.string.isRequired,
  handleClick: PropTypes.func,
}

export default CurrentSiteTile
